import React from 'react';
import { parsePhoneNumber } from 'libphonenumber-js/mobile';
import { Desensitize } from '@fuxi/eevee-ui';

type Props = {
  phone: string;
  iconStyle?: React.CSSProperties;
};

export const DesensitizeCountryPhone = ({ phone, iconStyle }: Props) => {
  try {
    const { countryCallingCode, nationalNumber } = parsePhoneNumber(phone);
    return (
      <span>
        {`+${countryCallingCode}`}
        <Desensitize content={nationalNumber} type="telephone" iconStyle={iconStyle || { display: 'none' }} />
      </span>
    );
  } catch (e) {
    return null;
  }
};
